export default function ModalLoaderDirective(module) {
    angular.module(module || 'app')
        .directive('modalLoader', modalLoader);

    function modalLoader() {
        var directive = {
            restrict: 'A',
            controller: controller,
            controllerAs: 'ml'
        };

        controller.$inject = ['$timeout', '$attrs', '$http', '$compile', '$scope', '$window'];
        function controller($timeout, $attrs, $http, $compile, $scope, $window) {
            var ctrl = this;

            ctrl.$onInit = function () {
                ctrl.delay = $attrs.delay ? parseInt($attrs.delay) : 800;
                ctrl.loadedModals = [];
                ctrl._modalQueue = [];
                if ($attrs.rootId) {
                    ctrl.rootId = parseInt($attrs.rootId);
                }
            };

            ctrl.load = function (modalName) {
                if (angular.element('#' + modalName).length) {
                    if (ctrl.loadedModals.indexOf(modalName) === -1) {
                        ctrl.loadedModals.push(modalName);
                    }
                }
                else if (ctrl.loadedModals.indexOf(modalName) === -1) {
                    ctrl.loadedModals.push(modalName);
                    ctrl._modalQueue.push(modalName);
                    $timeout.cancel(ctrl._requestTimer);
                    ctrl._requestTimer = $timeout(function () {
                        if (ctrl.rootId) {
                            $http.get('/api/modals/get/' + ctrl.rootId + '/', {
                                params: {
                                    modals: ctrl._modalQueue
                                }
                            })
                                .then(function (response) {
                                    var body = angular.element('body');
                                    var items = response.data;
                                    for (var i = 0; i < items.length; i++) {
                                        var modal = angular.element(items[i].markup);
                                        body.append(modal);
                                        new Foundation.Reveal(modal);
                                        $compile(modal.contents())($scope);
                                        $timeout(function () {
                                            if ($window.bindUmbracoFormHandling) {
                                                var button = this.modal.find('.umbraco-forms-form [type="submit"]:not(.cancel)');
                                                if (button.length) {
                                                    $window.bindUmbracoFormHandling(button);
                                                }
                                            }
                                            var innerModals = this.modal.find('.reveal');
                                            if (innerModals.length) {
                                                for (var j = 0; j < innerModals.length; j++) {
                                                    var innerModal = angular.element(innerModals[j]);
                                                    new Foundation.Reveal(innerModal);
                                                }
                                            }
                                        }.bind({ modal: modal }));
                                    }
                                })
                                .catch(function (error) {
                                    console.log(error);
                                });
                            ctrl._modalQueue = [];
                        }
                    }, ctrl.delay);
                }
            };
        }

        return directive;
    }
};